import { render } from "./productOrderBundleParts.vue?vue&type=template&id=ba03d224"
import script from "./productOrderBundleParts.vue?vue&type=script&lang=js"
export * from "./productOrderBundleParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__